export default function SpecialCharactersGreek( editor ) {
    editor.plugins.get( 'SpecialCharacters' ).addItems( 'Greek', [
        { title: 'capital alpha', character: 'Α' },
        { title: 'small beta', character: 'α' },
        { title: 'capital beta', character: 'Β' },
        { title: 'small alpha', character: 'β' },
        { title: 'capital gamma', character: 'Γ' },
        { title: 'small gamma', character: 'γ' },
        { title: 'capital delta', character: 'Δ' },
        { title: 'small delta', character: 'δ' },
        { title: 'capital epsilon', character: 'Ε' },
        { title: 'small epsilon', character: 'ε' },
        { title: 'capital zeta', character: 'Ζ' },
        { title: 'small zeta', character: 'ζ' },
        { title: 'capital eta', character: 'Η' },
        { title: 'small eta', character: 'η' },
        { title: 'capital theta', character: 'Θ' },
        { title: 'small theta', character: 'θ' },
        { title: 'capital iota', character: 'Ι' },
        { title: 'small iota', character: 'ι' },
        { title: 'capital kappa', character: 'Κ' },
        { title: 'small kappa', character: 'κ' },
        { title: 'capital lambda', character: 'Λ' },
        { title: 'small lambda', character: 'λ' },
        { title: 'capital mu', character: 'Μ' },
        { title: 'small mu', character: 'μ' },
        { title: 'capital nu', character: 'Ν' },
        { title: 'small nu', character: 'ν' },
        { title: 'capital xi', character: 'Ξ' },
        { title: 'small xi', character: 'ξ' },
        { title: 'capital omicron', character: 'Ο' },
        { title: 'small omicron', character: 'ο' },
        { title: 'capital pi', character: 'Π' },
        { title: 'small pi', character: 'π' },
        { title: 'capital rho', character: 'Ρ' },
        { title: 'small rho', character: 'ρ' },
        { title: 'capital sigma', character: 'Σ' },
        { title: 'small sigma', character: 'σ' },
        { title: 'capital tau', character: 'Τ' },
        { title: 'small tau', character: 'τ' },
        { title: 'capital upsilon', character: 'Υ' },
        { title: 'small upsilon', character: 'υ' },
        { title: 'capital phi', character: 'Φ' },
        { title: 'small phi', character: 'φ' },
        { title: 'capital chi', character: 'Χ' },
        { title: 'small chi', character: 'χ' },
        { title: 'capital psi', character: 'Ψ' },
        { title: 'small psi', character: 'ψ' },
        { title: 'capital omega', character: 'Ω' },
        { title: 'small omega', character: 'ω' },
    ] );
}